import { RetryPlugin } from '@module-federation/retry-plugin';

export const createRetryRemotePlugin = () =>
  RetryPlugin({
    retryTimes: 5,
    retryDelay: 2000,
    addQuery: true,
    onError: (context) => {
      console.warn(
        '[mf-retry] remote load failed after retries',
        context,
      );
    },
  });

export default createRetryRemotePlugin;
